"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var info = {
    utils: {
        httpUtils: {
            httpPost: function () {
                throw "not implemneted";
            },
            httpGet: function () {
                throw "not implemneted";
            },
        },
        config: {
            baseUrl: function () {
                throw "not implemneted";
            },
        },
    },
};
function getUtils() {
    return info.utils;
}
exports.getUtils = getUtils;
function setUtils(utils) {
    info.utils = utils;
    return info.utils;
}
exports.setUtils = setUtils;
